import React from "react";
import { AnimatePresence } from "framer-motion";
import { FaTimes } from "react-icons/fa";
import {
  ModalIconButton,
  ModalSectionBody,
  ModalSectionHeader,
  ModalContentStack,
  ModalScrollArea,
  ModalSectionBodySecondary,
  ModalSectionHeading,
  ModalOverlayMotionButton,
  ModalMotionPanel,
  ModalEyebrowText,
  ModalBodyText,
} from "components/global/styles/Modal.inline.styles";
type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  size?: "md" | "lg";
};
export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  actions,
  size = "md",
}) => (
  <AnimatePresence>
    {isOpen ? (
      <>
        <ModalOverlayMotionButton
          aria-label="Close modal"
          exit={{
            opacity: 0,
          }}
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          onClick={onClose}
        />

        <ModalSectionBody>
          <ModalMotionPanel
            $size={size}
            exit={{
              opacity: 0,
              scale: 0.96,
              y: 20,
            }}
            initial={{
              opacity: 0,
              scale: 0.96,
              y: 20,
            }}
            animate={{
              opacity: 1,
              scale: 1,
              y: 0,
            }}
            transition={{
              duration: 0.2,
              ease: "easeOut",
            }}
          >
            <ModalSectionHeader>
              <ModalContentStack>
                <ModalEyebrowText>Athspire Admin</ModalEyebrowText>
                <div>
                  <ModalSectionHeading>{title}</ModalSectionHeading>
                  {subtitle ? <ModalBodyText>{subtitle}</ModalBodyText> : null}
                </div>
              </ModalContentStack>

              <ModalIconButton onClick={onClose} type="button">
                <FaTimes />
              </ModalIconButton>
            </ModalSectionHeader>

            <ModalScrollArea>{children}</ModalScrollArea>

            {actions ? <ModalSectionBodySecondary>{actions}</ModalSectionBodySecondary> : null}
          </ModalMotionPanel>
        </ModalSectionBody>
      </>
    ) : null}
  </AnimatePresence>
);
export default Modal;
